import { render } from "./PriceStructureComponent.vue?vue&type=template&id=40bb9746"
import script from "./PriceStructureComponent.vue?vue&type=script&lang=js"
export * from "./PriceStructureComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__